/*global $*/
import React from "react";
import moment from "moment";
import { storage } from "../app-database";
import { servicios } from "./../properties";
import { callService, makeform, setCookie, descargas, descargasBinary, setCookiePortal, downloadCertificadoEco } from "../tools";
import { saveAs } from "file-saver";
import { movil } from "../app-movil";
import { URL_ENDPOINT_CODFILIACION } from "../properties";

const storageRef = storage.ref("generales");
const mensajeError = "Por el momento no es posible mostrar la documentación. Por favor, contacte a su Asesor Profesional en Seguros para solicitar la información.";
const modalCodPol = "#modal-codigo-pol";
var g_timer = null;

export const reciboPagado = (listaPolizas, numPoliza, numRecibo, ramo) => {
	return dispatch => {
		listaPolizas.map((item) => {
			if (item.generales.numPoliza == numPoliza) {
				item.generales.estatus = "";

				let registros = item.cobranza.registros.filter((recibos) => {
					return recibos.codNumRecibo != numRecibo;
				});

				item.cobranza.registros = registros;
			}
		});

		switch (ramo) {
			case "A":
				return { "type": "POLIZAS_PAGO_LLENAR_AUTOS", "autos": listaPolizas };
			case "G":
				return { "type": "POLIZAS_PAGO_LLENAR_GMM", "gm": listaPolizas };
			case "V":
				return { "type": "POLIZAS_PAGO_LLENAR_VIDA", "vida": listaPolizas };
			case "D":
				return { "type": "POLIZAS_PAGO_LLENAR_DANIOS", "danios": listaPolizas };
		}
	};
};

export const agregarPoliza = (oSolicitud) => {
	let servicio = new callService({
		service: "polizas.solicitud",
		secure: true,
		data: oSolicitud
	});

	return servicio.execute();
};

export const detailPoliza = (oSolicitud) => {
	let servicio = new callService({
		service: "utilerias.detallePoliza",  //"polizas.solicitud",
		secure: true,
		data: { poliza: oSolicitud.poliza } //oSolicitud
	});

	return servicio.execute();
};

function fechaformat(sFecha) {
	sFecha = sFecha.split("/").reverse();
	return sFecha[0] + sFecha[1] + sFecha[2];
}
function MyError() { this.message = { "codigoError": "ERROR", "mensaje": "Esta poliza no esta asociada a tu cuenta" }; }
MyError.prototype = Object.create(Error.prototype);
MyError.prototype.constructor = MyError;

const get=(url)=>{
	// Return a new promise.
	return new Promise(function(resolve, reject) {
	  // Do the usual XHR stuff
	  var req = new XMLHttpRequest();
	  req.open('GET', url);
  
	  req.onload = function() {
		// This is called even on 404 etc
		// so check the status
		if (req.status == 200) {
		  // Resolve the promise with the response text
		  resolve(req.response);
		}
		else {
		  // Otherwise reject with the status text
		  // which will hopefully be a meaningful error
		  reject(Error(req.statusText));
		}
	  };
  
	  // Handle network errors
	  req.onerror = function() {
		reject(Error("Network Error"));
	  };
  
	  // Make the request
	  req.send();
	});
}

export const getCodigoFiliacion=(idParticipante) => {
	// create a new XMLHttpRequest
	let xhr = new XMLHttpRequest();
	let resultClaves = "";

	//morelias
	const parames = {
		modoConsulta: "H",
		banCancelados: false,
		idParticipante
	}
	// Convert object to url
	const datosUrl = Object.entries(parames).map((parame) => `${parame.join("=")}`);
	const urlServicio = `${URL_ENDPOINT_CODFILIACION}?${datosUrl.join("&")}`;
	console.log(
		`Url Codigo Filiacion ................................`,
		urlServicio
	);
		
	return get(urlServicio).then((result) => {
		const resultPersona =JSON.parse(result);
		console.log("ResFech", resultPersona);
		if(resultPersona.personaDto.sistemasOrigen.sistemaOrigen){
			const {sistemaOrigen} = resultPersona.personaDto.sistemasOrigen;
			if(sistemaOrigen.length > 0){
				//resultClaves = sistemaOrigen.find((claves) => claves.);
				for(let claves of sistemaOrigen){
					const {valor} = claves;
					//const {valorClaveOrigen} 
					let findClave = Object.values(valor).find((dataValores) => dataValores.banPadre == true)
					console.log ("RESULTADO ", findClave);
					if(Object.keys(findClave || {}).length > 0){
						
						resultClaves = findClave.valorClaveOrigen;
						console.log("Clave Origen:", resultClaves);
						break;
					}
				}
			}
		}
		return resultClaves;
	}).catch((error)=> {
		console.log("Ocurrió un error para recuperar los datos del cod Filiacion", error);
		return "";
	});
}

export const actualizaPersona = (clienteUnico, rfc, fechaNac, detallesPoliza) => {

	let codFiliacion = "", idParticipante = "", RFC = rfc, fechaNacimiento = fechaNac, apaterno = "", amaterno = "", nombres = "";

	if (detallesPoliza.conductor.clienteUnico !== 'undefined' || detallesPoliza.conductor.clienteUnico !== null) {
		if (detallesPoliza.conductor.clienteUnico == clienteUnico) {
			console.log("conductor");
			//codFiliacion = clienteUnico;
			idParticipante = detallesPoliza.conductor.idParticipante;
			//codFiliacion = getCodigoFiliacion(idParticipante);
			apaterno = detallesPoliza.conductor.apellidoPaterno;
			amaterno = detallesPoliza.conductor.apellidoMaterno;
			nombres = detallesPoliza.conductor.nombres;
			//RFC = oDatos.conductor.rfc.trim();
			//fechaNacimiento = fechaformat(oDatos.conductor.fchNacimiento);
		}
	}
	if (detallesPoliza.contratante.clienteUnico !== 'undefined' || detallesPoliza.contratante.clienteUnico !== null) {
		if (detallesPoliza.contratante.clienteUnico == clienteUnico) {
			console.log("contratante");
			//codFiliacion = clienteUnico;
			idParticipante = detallesPoliza.contratante.idParticipante;
			//codFiliacion = getCodigoFiliacion(idParticipante);
			apaterno = detallesPoliza.contratante.apellidoPaterno;
			amaterno = detallesPoliza.contratante.apellidoMaterno;
			nombres = detallesPoliza.contratante.nombres;
			//RFC = oDatos.contratante.rfc.trim();
			//fechaNacimiento = fechaformat(oDatos.contratante.fchNacimiento);
		}
	}
	
	getCodigoFiliacion(idParticipante).then((codFiliacion) =>{
		console.log("getCodigoFiliacion", codFiliacion);
		if (codFiliacion != "" && idParticipante != "" && RFC != "" && fechaNacimiento != "") {
			let servicio = new callService({
				service: "utilerias.actualizaPersona",
				secure: true,
				data: { codigoFiliacion: clienteUnico, idParticipante: idParticipante, RFC: RFC, fechaNacimiento: fechaNacimiento, apellidoPaterno: apaterno, nombre: nombres, usuarioAudit: "operadorcrm" }
			});
	
			return servicio.execute();
	
		} else {
			throw new MyError();
		}
	});



};

export const updatePersona = (clienteUnico, rfc, fechaNac) => {
	let servicio = new callService({
		service: "utilerias.actualizaPersona",
		secure: true,
		data: { codigoFiliacion: clienteUnico, RFC: rfc, fechaNacimiento: fechaNac }
	});

	return servicio.execute();

};


export const descargarEdoCuenta = (sDocumento, sArchivo) => {
	return dispatch => {
		descargasBinary(servicios.descargas.edocuenta + "?documento=" + sDocumento, sArchivo);
		dispatch({ "type": "DESCARGAS_SET_EVENT", "evento": "DescargaEdoCuenta" });
	};
};

// export const descargarRCO = (sPoliza) => {
// 	return dispatch => {
// 		descargas(servicios.descargas.rco+"?poliza=" + sPoliza, "RCO.pdf");
// 		dispatch({ "type": "DESCARGAS_SET_EVENT", "evento": "DescargaRCO"});
// 	};
// };

export const descargarRCOv2 = (sPoliza, sVersion) => {
	return dispatch => {
		var id = new Date().getTime();
		dispatch({ "type": "DESCARGAS_LISTA_ADD", "descarga": { "id": id, "nombre": (sPoliza) + ".pdf", "completo": 0 } });
		dispatch({ "type": "DESCARGAS_SET_EVENT", "evento": "DescargaRCO" });
		let llamadaSeguro = new callService({
			service: "descargas.rcov2",
			"secure": true,
			data: {
				"poliza": sPoliza,
				"version": sVersion,
			}
		}).execute().then(sResultado => {
			console.log("Resultado " + sResultado)
			if (sResultado.error) {
				dispatch({ "type": "DESCARGAS_LISTA_UPDATE", "descarga": { "id": id, "nombre": (sPoliza) + ".pdf", "completo": 100, "error": true } });
			} else {
				dispatch({ "type": "DESCARGAS_LISTA_UPDATE", "descarga": { "id": id, "nombre": (sPoliza) + ".pdf", "completo": 100 } });
			}
			download(sResultado.contenido, "RCO.pdf");
		}).catch(error => {
			dispatch({ "type": "DESCARGAS_LISTA_UPDATE", "descarga": { "id": id, "nombre": (sPoliza) + ".pdf", "completo": 100, "error": true } });
			dispatch({ "type": "MODAL_ALERT_MESSAGES_SHOW", "titulo": "Importante", "mensaje": mensajeError });
		});
	};
};

export const descargarCertificadoEco = (certificado, numPoliza, bMovil) => {
	return dispatch => {
		if (!bMovil) {
			console.log("descargar certificado eco action web: ", certificado, numPoliza);
			downloadCertificadoEco(certificado, numPoliza, `${numPoliza}.pdf`);
			dispatch({ "type": "DESCARGAS_SET_EVENT", "evento": "DescargaCertificadoECO" });
		} else {
			console.log("descargar certificado eco action movile: ", certificado, numPoliza);
			dispatch({ "type": "LOADER_SHOW" });

			let llamadaSeguro = new callService({
				service: "descargas.certificadoECO",
				"secure": true,
				data: {
					"numPoliza": numPoliza,
					"certificado": certificado
				}
			}).execute().then(sResultado => {
				dispatch({ "type": "LOADER_HIDE" });

				movil("descargaPoliza", { "return": "descargaPoliza", "proceso": "descargaPoliza", "numPoliza": numPoliza, "dataPdf": sResultado.contenido });
			}).catch(error => {
				dispatch({ "type": "LOADER_HIDE" });
				dispatch({ "type": "MODAL_ALERT_MESSAGES_SHOW", "titulo": "Importante", "mensaje": mensajeError });
			});
		}
	}
}

export const descargarCertificado = (sPoliza, sCertificado) => {
	console.log(servicios.descargas.certificado + "?numPoliza=" + sPoliza + "&certificado=" + sCertificado);
	return dispatch => {
		dispatch({ "type": "LOADER_SHOW" });
		descargas(servicios.descargas.certificado + "?numPoliza=" + sPoliza + "&certificado=" + sCertificado, "GNP");
		dispatch({ "type": "DESCARGAS_SET_EVENT", "evento": "DescargaCertificado" });
		dispatch({ "type": "LOADER_HIDE" });
	};
};

export const descargarCertificadoAzul = (sPoliza, sCertificado, bMovil) => {
	console.log(servicios.descargas.certificadoazul + "?numPoliza=" + sPoliza + "&certificado=" + sCertificado);
	return dispatch => {
		if (bMovil) {
			dispatch({ "type": "LOADER_SHOW" });

			let llamadaSeguro = new callService({
				service: "descargas.certificadoazul",
				"secure": true,
				data: {
					"noPoliza": sPoliza,
					"noCertificado": sCertificado
				}
			}).execute().then(sResultado => {
				dispatch({ "type": "LOADER_HIDE" });

				movil("descargaPoliza", { "return": "descargaPoliza", "proceso": "descargaPoliza", "numPoliza": sPoliza, "dataPdf": sResultado.contenido });
			}).catch(error => {
				dispatch({ "type": "LOADER_HIDE" });
				dispatch({ "type": "MODAL_ALERT_MESSAGES_SHOW", "titulo": "Importante", "mensaje": mensajeError });
			});
		} else {
			/////////////////////////////////////////// DESCARGAS CMPT ///////////////////////////////////////////
			var id = new Date().getTime();
			dispatch({ "type": "DESCARGAS_LISTA_ADD", "descarga": { "id": id, "nombre": (sPoliza) + ".pdf", "completo": 0 } });
			/////////////////////////////////////////// DESCARGAS CMPT ///////////////////////////////////////////

			let llamadaSeguro = new callService({
				service: "descargas.certificadoazul",
				"secure": true,
				data: {
					"noPoliza": sPoliza,
					"noCertificado": sCertificado
				}
			}).execute().then(sResultado => {
				//dispatch({ "type": "LOADER_HIDE" });

				/////////////////////////////////////////// DESCARGAS CMPT ///////////////////////////////////////////
				if (sResultado.error) {
					dispatch({ "type": "DESCARGAS_LISTA_UPDATE", "descarga": { "id": id, "nombre": sPoliza, "completo": 100, "error": true } });
				} else {
					dispatch({ "type": "DESCARGAS_LISTA_UPDATE", "descarga": { "id": id, "nombre": sPoliza, "completo": 100 } });
				}
				/////////////////////////////////////////// DESCARGAS CMPT ///////////////////////////////////////////

				let archivo = "";
				archivo = "Póliza_" + Number(sPoliza) + ".pdf";
				dispatch({ "type": "DESCARGAS_SET_EVENT", "evento": "DescargaPoliza" });

				download(sResultado.contenido, archivo);
			}).catch(error => {
				//dispatch({ "type": "LOADER_HIDE" });

				/////////////////////////////////////////// DESCARGAS CMPT ///////////////////////////////////////////
				dispatch({ "type": "DESCARGAS_LISTA_UPDATE", "descarga": { "id": id, "nombre": sPoliza, "completo": 100, "error": true } });
				/////////////////////////////////////////// DESCARGAS CMPT ///////////////////////////////////////////

				dispatch({ "type": "MODAL_ALERT_MESSAGES_SHOW", "titulo": "Importante", "mensaje": mensajeError });
			});
		}

	};
};

export const descargarTarjetas = (sClienteUnico, sPoliza, sVersion, sProductos) => {
	return dispatch => {
		/////////////////////////////////////////// DESCARGAS CMPT ///////////////////////////////////////////
		var id = new Date().getTime();
		dispatch({ "type": "DESCARGAS_LISTA_ADD", "descarga": { "id": id, "nombre": "Tarjetas.zip", "completo": 0 } });
		dispatch({ "type": "DESCARGAS_SET_EVENT", "evento": "DescargaTarjeta" });
		/////////////////////////////////////////// DESCARGAS CMPT ///////////////////////////////////////////

		let llamadaSeguro = new callService({
			service: "descargas.tarjetas",
			"secure": true,
			data: {
				"clienteunico": sClienteUnico,
				"poliza": sPoliza,
				"version": sVersion,
				"productos": sProductos
			}
		}).execute().then(sResultado => {
			//dispatch({ "type": "LOADER_HIDE" });

			/////////////////////////////////////////// DESCARGAS CMPT ///////////////////////////////////////////
			if (sResultado.error) {
				dispatch({ "type": "DESCARGAS_LISTA_UPDATE", "descarga": { "id": id, "nombre": "Tarjetas.zip", "completo": 100, "error": true } });
			} else {
				dispatch({ "type": "DESCARGAS_LISTA_UPDATE", "descarga": { "id": id, "nombre": "Tarjetas.zip", "completo": 100 } });
			}
			/////////////////////////////////////////// DESCARGAS CMPT ///////////////////////////////////////////

			let archivo = "";

			download(sResultado.contenido, "Tarjetas.zip");
		}).catch(error => {
			//dispatch({ "type": "LOADER_HIDE" });

			/////////////////////////////////////////// DESCARGAS CMPT ///////////////////////////////////////////
			dispatch({ "type": "DESCARGAS_LISTA_UPDATE", "descarga": { "id": id, "nombre": "Tarjetas.zip", "completo": 100, "error": true } });
			/////////////////////////////////////////// DESCARGAS CMPT ///////////////////////////////////////////

			dispatch({ "type": "MODAL_ALERT_MESSAGES_SHOW", "titulo": "Importante", "mensaje": mensajeError });
		});
	};
};

export const descargarDocumento = (sDocumento, sPoliza, sVersion, sRecibo, bMovil) => {
	return dispatch => {
		if (bMovil) {
			dispatch({ "type": "LOADER_SHOW" });

			let llamadaSeguro = new callService({
				service: "descargas." + sDocumento,
				"secure": true,
				data: {
					"poliza": sPoliza,
					"version": sVersion,
					"recibo": sRecibo
				}
			}).execute().then(sResultado => {
				dispatch({ "type": "LOADER_HIDE" });

				movil("descargaPoliza", { "return": "detallePoliza", "proceso": "descargaPoliza", "numPoliza": sPoliza, "dataPdf": sResultado.contenido });
			}).catch(error => {
				dispatch({ "type": "LOADER_HIDE" });
				dispatch({ "type": "MODAL_ALERT_MESSAGES_SHOW", "titulo": "Importante", "mensaje": mensajeError });
			});
		} else {
			/////////////////////////////////////////// DESCARGAS CMPT ///////////////////////////////////////////
			var id = new Date().getTime();
			dispatch({ "type": "DESCARGAS_LISTA_ADD", "descarga": { "id": id, "nombre": (sRecibo ? sRecibo : sPoliza) + ".pdf", "completo": 0 } });
			/////////////////////////////////////////// DESCARGAS CMPT ///////////////////////////////////////////

			let llamadaSeguro = new callService({
				service: "descargas." + sDocumento,
				"secure": true,
				data: {
					"poliza": sPoliza,
					"version": sVersion,
					"recibo": sRecibo
				}
			}).execute().then(sResultado => {
				//dispatch({ "type": "LOADER_HIDE" });

				/////////////////////////////////////////// DESCARGAS CMPT ///////////////////////////////////////////
				if (sResultado.error) {
					dispatch({ "type": "DESCARGAS_LISTA_UPDATE", "descarga": { "id": id, "nombre": sRecibo, "completo": 100, "error": true } });
				} else {
					dispatch({ "type": "DESCARGAS_LISTA_UPDATE", "descarga": { "id": id, "nombre": sRecibo, "completo": 100 } });
				}
				/////////////////////////////////////////// DESCARGAS CMPT ///////////////////////////////////////////

				let archivo = "";

				switch (sDocumento) {
					case "poliza":
						archivo = "Póliza_" + Number(sPoliza) + ".pdf";
						dispatch({ "type": "DESCARGAS_SET_EVENT", "evento": "DescargaPoliza" });
						break;
					case "rco":
						archivo = "CertificadoRCO_" + Number(sPoliza) + ".pdf";
						dispatch({ "type": "DESCARGAS_SET_EVENT", "evento": "DescargaCertificadoRCO" });
						break;
					case "condicionesgenerales":
						archivo = "Condiciones generales_" + Number(sPoliza) + ".pdf";
						dispatch({ "type": "DESCARGAS_SET_EVENT", "evento": "DescargaCondiciones" });
						break;
				}

				if (sRecibo && sRecibo != "") {
					archivo = "Recibo_" + sRecibo + ".pdf";
					dispatch({ "type": "DESCARGAS_SET_EVENT", "evento": "DescargaRecibo" });
				}

				condicionDownload(sResultado.contenido, archivo, sPoliza, sVersion);

			}).catch(error => {
				dispatch({ "type": "DESCARGAS_LISTA_UPDATE", 
				"descarga": { "id": id, "nombre": sRecibo, 
				"completo": 100, "error": true } });
				dispatch({ "type": "MODAL_ALERT_MESSAGES_SHOW", 
				"titulo": "Importante", 
				"mensaje": 
				mensajeError 
				});
			});
		}
	};
};

function condicionDownload (resultadoContenido, archivo, sPoliza, sVersion) {
	console.log('condicionDownload');
	if(resultadoContenido !== '' && resultadoContenido !== null) {
		console.log('si trae contenido',archivo);
		download(resultadoContenido, archivo);
	} else {
		console.log('no trae contenido');
		obtenerIdDocumento(sPoliza, sVersion);
	}
}

function obtenerIdDocumento (sPoliza, sVersion) {
	new callService({
		service: "descargas.orquestadorDocumentos",
		"secure": true,
		data: {
			"poliza": sPoliza,
			"version": sVersion,
			"cveDocumento": "CO"
		}
	}).execute().then(sResultado => {
		console.log(sResultado);
		if(sResultado) {
			descargarDocumento('poliza ', sPoliza, sVersion); 
		} else {
			console.log('error')
		}
	}).catch(error => {
		console.log(error);
		dispatch({ 
			"type": "MODAL_ALERT_MESSAGES_SHOW", 
			"titulo": "Importante", 
			"mensaje": mensajeError
		});
	});
}

export const descargarRcUsa = (poliza) => {
	return dispatch => {
		const numPoliza = poliza.generales.numPoliza;
		const numVersion = poliza.generales.numVersion;
		const nombre = `${numPoliza}.pdf`;

		// Agregar a la lista de descargas
		var id = new Date().getTime();
		dispatch({ "type": "DESCARGAS_LISTA_ADD", "descarga": { "id": id, "nombre": nombre, "completo": 0 } });

		new callService({
			service: "descargas.polizarcusa",
			secure: true,
			data: {
				poliza: numPoliza,
				version: numVersion
			}
		}).execute().then(resultado => {
			// Indicar descarga completa
			const message = {"type": "DESCARGAS_LISTA_UPDATE", "descarga": { "id": id, "nombre": nombre, "completo": 100}}; 
			if (resultado.error) {
				message.error = true;
			}
			dispatch(message);

			// Indicar el tipo de evento de descarga
			dispatch({ "type": "DESCARGAS_SET_EVENT", "evento": "DescargaPolizaRcUsa" })
			
			const archivo = "RC_" + Number(numPoliza) + ".pdf";
			download(resultado.contenido, archivo);
		}).catch(error => {
			// Indicar descarga completa con error
			dispatch({ "type": "DESCARGAS_LISTA_UPDATE", "descarga": { "id": id, "nombre": nombre, "completo": 100, "error": true } });

			// Mostrar mensaje
			let mensaje;
			if(moment(poliza.generales.fchVigenciaInicial, "DD/MM/YYYY").isBefore("2020-10-10")){
				mensaje = <span>
							Por el momento no tenemos tu Certificado RC EUA 
							disponible para descarga. Si tu Póliza inició vigencia antes del 10 de octubre de 2020,
							ingresa 
							<a href="http://chubbmexico.net/rcgnp.htm" 
							className="orange-text" target="_blank" rel="noopener noreferrer">
							aquí</a> para generar tu Certificado y consultar sus Condiciones Generales
						</span>;
			}else{
				mensaje = <span>
							Por el momento no es posible descargar tu certificado de RC EUA. 
							Por favor contacta a tu agente GNP o llama a la línea GNP 55 5227 9000 para más información
						</span>;
			}
			dispatch({"type": "MODAL_ALERT_MESSAGES_SHOW", "titulo": "Importante", "mensaje": () => mensaje});
		});
	};
};

export const descargarCondiciones = (oPoliza) => {
	return dispatch => {
		/////////////////////////////////////////// DESCARGAS CMPT ///////////////////////////////////////////
		const id = new Date().getTime();
		dispatch({ "type": "DESCARGAS_LISTA_ADD", "descarga": { "id": id, "nombre": "condiciones-generales", "completo": 0 } });
		dispatch({ "type": "DESCARGAS_SET_EVENT", "evento": "DescargaCondiciones" });
		/////////////////////////////////////////// DESCARGAS CMPT ///////////////////////////////////////////

		new callService({
			service: "descargas.generales",
			secure: true,
			data: oPoliza
		}).execute().then(resultado => {
			console.log(resultado);

			if (resultado.hasOwnProperty("documento")) {
				dispatch({ "type": "DESCARGAS_LISTA_UPDATE", "descarga": { "id": id, "nombre": resultado.documento, "completo": 50 } });
				storageRef.child(resultado.documento).getDownloadURL().then(function (url) {
					var xhr = new XMLHttpRequest();
					xhr.responseType = "blob";
					xhr.withCredentials = false;
					xhr.onerror = function (XMLHttpRequest, textStatus, errorThrown) {
						var link = document.createElement("a");
						link.href = url;
						link.download = resultado.documento;
						link.click();
						dispatch({ "type": "DESCARGAS_LISTA_UPDATE", "descarga": { "id": id, "nombre": resultado.documento, "completo": 100 } });
					};
					xhr.onload = function (event) {
						var blob = xhr.response;
						saveAs(blob, resultado.documento);
						dispatch({ "type": "DESCARGAS_LISTA_UPDATE", "descarga": { "id": id, "nombre": resultado.documento, "completo": 100 } });
					};
					xhr.open("GET", url);
					xhr.send();
				}).catch(function (error) {
					dispatch({ "type": "DESCARGAS_LISTA_UPDATE", "descarga": { "id": id, "completo": 100, "error": true } });
					dispatch({ "type": "MODAL_ALERT_MESSAGES_SHOW", 
					"titulo": "Importante", 
					"mensaje": 
					mensajeError
					 });
				});
			} else if (resultado.hasOwnProperty("documentoSantander")) {
				const content = resultado.documentoSantander

				/////////////////////////////////////////// DESCARGAS CMPT ///////////////////////////////////////////
				if (resultado.error) {
					dispatch({ "type": "DESCARGAS_LISTA_UPDATE", "descarga": { "id": id, "nombre": "Error", "completo": 100, "error": true } });
				} else {
					dispatch({ "type": "DESCARGAS_LISTA_UPDATE", "descarga": { "id": id, "nombre": "CondicionesGenerales", "completo": 100 } });
				}
				/////////////////////////////////////////// DESCARGAS CMPT ///////////////////////////////////////////

				let archivo = "";

				archivo = "Condiciones generales_" + Number(oPoliza.numPoliza) + ".pdf";
				dispatch({ "type": "DESCARGAS_SET_EVENT", "evento": "DescargaCondiciones" });
				download(content, archivo);
			} else {
				dispatch({ "type": "DESCARGAS_LISTA_UPDATE", "descarga": { "id": id, "completo": 100, "error": true } });
				dispatch({ "type": "MODAL_ALERT_MESSAGES_SHOW", 
				"titulo": "Importante", 
				"mensaje": 
				mensajeError 
				});
			}
		}).catch(error => {
			console.log(error);
			dispatch({ "type": "DESCARGAS_LISTA_UPDATE", "descarga": { "id": id, "completo": 100, "error": true } });
			dispatch({ "type": "MODAL_ALERT_MESSAGES_SHOW", 
			"titulo": "Importante", 
			"mensaje": 
			mensajeError
			});
		});
	};
};

export const consultarEdoCuenta = (sPoliza) => {
	return dispatch => {
		new callService({
			service: "edocuenta.consultar",
			"secure": true,
			data: {
				"poliza": sPoliza
			}
		}).execute().then(oResultado => {
			dispatch({ "type": "EDOCUENTA_LLENAR", "edocuenta": oResultado.executeQueryResponse.edo });
		});
	};
};

export const consultarFiniquitos = (numPoliza) => {
	return dispatch => {
		new callService({
			service: "finiquitos.listadoFiniquitos",
			"secure": true,
			data: {
				"numPoliza": numPoliza
			}
		}).execute().then(oResultado => {
			dispatch({ "type": "FINIQUITOS_LLENAR", "finiquitos": oResultado.consultarDocumentosResponse.documentosPoliza.documentoPoliza });
		});
	};
};

export const descargarFiniquito = (idFiniquito, nombreDocumento) => {
	return dispatch => {

		var id = new Date().getTime();
		dispatch({ "type": "DESCARGAS_LISTA_ADD", "descarga": { "id": id, "nombre": nombreDocumento, "completo": 0 } });
		dispatch({ "type": "DESCARGAS_SET_EVENT", "evento": "DescargaFiniquito" });
		/////////////////////////////////////////// DESCARGAS CMPT ///////////////////////////////////////////

		new callService({
			service: "finiquitos.descargaFiniquito",
			"secure": true,
			data: {
				"idDocumento": idFiniquito,
			}
		}).execute().then(sResultado => {

			/////////////////////////////////////////// DESCARGAS CMPT ///////////////////////////////////////////
			if (sResultado.error) {
				dispatch({ "type": "DESCARGAS_LISTA_UPDATE", "descarga": { "id": id, "nombre": nombreDocumento, "completo": 100, "error": true } });
			} else {
				dispatch({ "type": "DESCARGAS_LISTA_UPDATE", "descarga": { "id": id, "nombre": nombreDocumento, "completo": 100 } });
			}
			/////////////////////////////////////////// DESCARGAS CMPT ///////////////////////////////////////////

			download(sResultado.obtenerArchivoRetencionResponse.attachment, nombreDocumento);
		}).catch(error => {
			/////////////////////////////////////////// DESCARGAS CMPT ///////////////////////////////////////////
			dispatch({ "type": "DESCARGAS_LISTA_UPDATE", "descarga": { "id": id, "nombre": nombreDocumento, "completo": 100, "error": true } });
			/////////////////////////////////////////// DESCARGAS CMPT ///////////////////////////////////////////
			dispatch({ "type": "MODAL_ALERT_MESSAGES_SHOW", 
			"titulo": "Importante", 
			"mensaje": 
			mensajeError
			});
		});

	};
};

export const consultarRecibos = (sPoliza, fIni, fFin) => {
	return dispatch => {
		new callService({
			service: "recibos.consultar",
			"secure": true,
			data: {
				"poliza": sPoliza,
				"fechaIni": fIni.split("/")[2] + "-" + fIni.split("/")[1] + "-" + fIni.split("/")[0],
				"fechaFin": fFin.split("/")[2] + "-" + fFin.split("/")[1] + "-" + fFin.split("/")[0],
			}
		}).execute().then(oResultado => {
			dispatch({ "type": "RECIBOS_LLENAR", "recibos": oResultado.registros });
		});
	};
};

export const obtenerMediosContacto = () => {
	return dispatch => {
		dispatch({ "type": "MI_PERFIL_SET_LOAD_LOCAL", "load": true });
		new callService({
			service: "miPerfil.obtenerMedios",
			"secure": true,
			data: {}
		}).execute().then(body => {
			if (body.hasOwnProperty("error")) {
				$(modalCodPol).modal("hide");
				dispatch({
					"type": "MODAL_ALERT_MESSAGES_SHOW",
					"titulo": "Error",
					"mensaje": "Hubo un error al obtener número celular. Favor de intentar más tarde."
				});

			}
			else {
				for (var telefono of body.telefonos) {
					if (telefono.hasOwnProperty("propositoContacto")) {
						for (var proposito of telefono.propositoContacto) {
							if (proposito.cvePropositoContacto === "MED") {
								if (telefono.tipoContacto.cveTipoContacto === "TLCL" && telefono.hasOwnProperty("valorMedioContacto")) {
									dispatch({
										"type": "MI_PERFIL_SET_DATOS_OTP",
										"numero": telefono.lada + " " + telefono.valorMedioContacto,
										"correo": ""
									});
								}
							}
						}
					}
				}

			}
		}).catch(error => {
			dispatch({ "type": "MI_PERFIL_SET_LOAD_LOCAL", "load": false });
			$(modalCodPol).modal("hide");
			if (error.message.mensaje !== "") {
				dispatch({
					"type": "MODAL_ALERT_MESSAGES_SHOW",
					"titulo": "Error",
					"mensaje": "Hubo un error al obtener número celular. Favor de intentar más tarde."
				});
			}
		});
	};
};


function startTimer() {
	g_timer = setTimeout(() => {
		document.getElementById("btnCancelarCodigo").click();
	}, 300000);
}

export const generarOtpBan = (item) => {
	console.log("Se generará OTP");
	return dispatch => {
		dispatch({
			"type": "MI_PERFIL_SET_LOAD_LOCAL",
			"load": true
		});
		new callService({
			service: "otp.obtenerOtpBan",
			"secure": true,
			data: {}
		}).execute().then(body => {
			dispatch({
				"type": "MI_PERFIL_SET_LOAD_LOCAL",
				"load": false
			});
			if (body.hasOwnProperty("error")) {
				$(modalCodPol).modal("toggle");
				dispatch({
					"type": "MODAL_ALERT_MESSAGES_SHOW",
					"titulo": "Error",
					"mensaje": "Hubo un error al generar el OTP. Favor de intentar más tarde."
				});

			}
			else {
				if (body.enviarOtpResponse.resultado) {

					clearTimeout(g_timer);
					startTimer();
					console.log("Se generó con éxito el OTP");
					dispatch({
						"type": "MI_PERFIL_SET_OPERACION",
						"idOperacion": body.enviarOtpResponse.idOperacion,
						"codOtp": body.enviarOtpResponse.codOtp
					});
				}
				else {
					console.log(body.enviarOtpResponse.mensaje);
					dispatch({ "type": "MI_PERFIL_SET_LOAD_LOCAL", "load": false });
					$(modalCodPol).modal("toggle");
					if (body.enviarOtpResponse.mensaje === "Se recibira llamada de parte del operador") {
						switch (item.generales.detalle) {
							case "inversion":
								if (item.generales.cveProdTecnico === "CT65I") {
									dispatch({ "type": "HOME_SET_EVENT", "evento": "OTPNoActivo-CodigoOTP-Consolida" });
								}
								else if (item.generales.cveProdTecnico === "FB20I" || item.generales.cveProdTecnico === "FB65I") {
									dispatch({ "type": "HOME_SET_EVENT", "evento": "OTPNoActivo-CodigoOTP-Elige" });
								}
								else {
									dispatch({ "type": "HOME_SET_EVENT", "evento": "OTPNoActivo-CodigoOTP-VInversion" });
								}
								break;
							case "capitaliza":
								dispatch({ "type": "HOME_SET_EVENT", "evento": "OTPNoActivo-CodigoOTP-Capitaliza" });
								break;
							default:
								dispatch({ "type": "HOME_SET_EVENT", "evento": "OTPNoActivo-CodigoOTP-Vida" });
								break;
						}
						dispatch({
							"type": "MODAL_ALERT_MESSAGES_SHOW",
							"titulo": "Importante",
							"mensaje":
						    `Para nosotros es muy importante la seguridad de tu información y las transacciones que realizarás, 
							por ello recibirás una llamada de validación de nuestro Call Center en un lapso máximo de 48 horas, 
							para poder acceder a tu información. Si lo prefieres puedes llamarnos al 55 5227 9000 o 01 (55) 5227 9000, 
							en la opción 7 de lunes a viernes de 8:00 a 20:00 horas. y sábados de 8:00 a 14:00 horas.`
						});
					}
					else {
						dispatch({
							"type": "MODAL_ALERT_MESSAGES_SHOW",
							"titulo": "Error",
							"mensaje": body.enviarOtpResponse.mensaje
						});
					}
				}

			}
		}).catch(error => {
			dispatch({ "type": "MI_PERFIL_SET_LOAD_LOCAL", "load": false });
			$(modalCodPol).modal("toggle");
			dispatch({
				"type": "MODAL_ALERT_MESSAGES_SHOW",
				"titulo": "Error",
				"mensaje": "Hubo un error al generar el OTP. Favor de intentar más tarde."
			});
		});
	};
};

export const validarOtpBan = (codigo, operacion, rt, item) => {
	return dispatch => {
		dispatch({
			"type": "MI_PERFIL_SET_ERROR",
			"error": false
		});

		new callService({
			service: "otp.validarOtpBan",
			"secure": true,
			data: { codigo: codigo, operacion: operacion, refreshtoken: rt }
		}).execute().then(body => {
			if (body.hasOwnProperty("jwt")) {

				switch (item.generales.detalle) {
					case "inversion":
						if (item.generales.cveProdTecnico === "CT65I") {
							dispatch({ "type": "HOME_SET_EVENT", "evento": "OTPCorrecto-CodigoOTP-Consolida" });
						}
						else if (item.generales.cveProdTecnico === "FB20I" || item.generales.cveProdTecnico === "FB65I") {
							dispatch({ "type": "HOME_SET_EVENT", "evento": "OTPCorrecto-CodigoOTP-Elige" });
						}
						else {
							dispatch({ "type": "HOME_SET_EVENT", "evento": "OTPCorrecto-CodigoOTP-VInversion" });
						}
						break;
					case "capitaliza":
						dispatch({ "type": "HOME_SET_EVENT", "evento": "OTPCorrecto-CodigoOTP-Capitaliza" });
						break;
					default:
						dispatch({ "type": "HOME_SET_EVENT", "evento": "OTPCorrecto-CodigoOTP-Vida" });
						break;
				}
				$.ajax({
					url: servicios.authLtpa,
					type: "post",
					dataType: "json",
					data: JSON.stringify({ "jwt": body.jwt }),
					/*xhrFields: {
					  withCredentials: true
					},*/
					success: function (data) {
						console.log("Respuesta", data);
						document.cookie = "LtpaToken2=" + data.ltpav2 + ";expires=" + data.Expires + ";domain=.gnp.com.mx";
						new callService({
							service: "encripta",
							secure: true,
							data: { "lista": [{ "campo": "poliza", "valor": item.generales.numPoliza }] }
						}).execute().then((respuesta) => {
							console.log("Respuesta", respuesta);
							dispatch({ "type": "MI_PERFIL_SET_LOAD_LOCAL", "load": false });
							$(modalCodPol).modal("toggle");

							setCookie(respuesta.poliza);
							setCookiePortal(item.clienteUnico);

							if (item.generales.detalle === "capitaliza") {
								makeform(servicios.polizas.vidaCapitaliza, {
									"emailV": respuesta.email,
									"numeroPolizaV": respuesta.poliza
								}, "POST");
							} else {
								makeform(servicios.polizas.vidaInversion, {
									"correo": respuesta.email,
									"numPoliza": respuesta.poliza,
									"codFiliacion": respuesta.ccu,
									"nombreCompleto": respuesta.nombre
								}, "GET");
							}

						}).catch((error) => {
							console.log("Error", error);
							dispatch({ "type": "MI_PERFIL_SET_LOAD_LOCAL", "load": false });
							dispatch({
								"type": "MODAL_ALERT_MESSAGES_SHOW",
								"titulo": "Error",
								"mensaje": "Hubo problemas al generar el detalle"
							});
						});
					},
					error: function (data) {
						console.log("Error", data);
						document.cookie = "LtpaToken2=" + data.ltpav2 + ";expires=" + data.Expires + ";domain=.gnp.com.mx";
						new callService({
							service: "encripta",
							secure: true,
							data: { "lista": [{ "campo": "poliza", "valor": item.generales.numPoliza }] }
						}).execute().then((respuestaEncripta) => {
							console.log("Respuesta", respuestaEncripta);
							dispatch({ "type": "MI_PERFIL_SET_LOAD_LOCAL", "load": false });
							$(modalCodPol).modal("toggle");

							setCookie(respuestaEncripta.poliza);
							setCookiePortal(item.clienteUnico);

							if (item.generales.detalle === "capitaliza") {
								makeform(servicios.polizas.vidaCapitaliza, {
									"emailV": respuestaEncripta.email,
									"numeroPolizaV": respuestaEncripta.poliza
								}, "POST");
							} else {
								makeform(servicios.polizas.vidaInversion, {
									"correo": respuestaEncripta.email,
									"numPoliza": respuestaEncripta.poliza,
									"codFiliacion": respuestaEncripta.ccu,
									"nombreCompleto": respuestaEncripta.nombre
								}, "GET");
							}

						}).catch((errorFail) => {
							console.log("errorFail", errorFail);
							dispatch({ "type": "MI_PERFIL_SET_LOAD_LOCAL", "load": false });
							dispatch({
								"type": "MODAL_ALERT_MESSAGES_SHOW",
								"titulo": "Error",
								"mensaje": "Hubo problemas al generar el detalle"
							});
						});
					}
				});
			}
			else {
				dispatch({
					"type": "MI_PERFIL_SET_LOAD_LOCAL",
					"load": false
				});
				if (body.error) {
					if (body.tipo === "intentos") {
						$(modalCodPol).modal("toggle");
						dispatch({
							"type": "MODAL_ALERT_MESSAGES_SHOW",
							"titulo": "Error",
							"mensaje": "Has superado el número de intentos.Por tu seguridad, la generación de OTPs ha sido bloqueda, intentalo mas tarde."
						});

					}
					else if (body.tipo === "codigo") {
						dispatch({
							"type": "MI_PERFIL_SET_ERROR",
							"error": true
						});
						switch (item.generales.detalle) {
							case "inversion":
								if (item.generales.cveProdTecnico === "CT65I") {
									dispatch({ "type": "HOME_SET_EVENT", "evento": "OTPIncorrecto-CodigoOTP-Consolida" });
								}
								else if (item.generales.cveProdTecnico === "FB20I" || item.generales.cveProdTecnico === "FB65I") {
									dispatch({ "type": "HOME_SET_EVENT", "evento": "OTPIncorrecto-CodigoOTP-Elige" });
								}
								else {
									dispatch({ "type": "HOME_SET_EVENT", "evento": "OTPIncorrecto-CodigoOTP-VInversion" });
								}
								break;
							case "capitaliza":
								dispatch({ "type": "HOME_SET_EVENT", "evento": "OTPIncorrecto-CodigoOTP-Capitaliza" });
								break;
							default:
								dispatch({ "type": "HOME_SET_EVENT", "evento": "OTPIncorrecto-CodigoOTP-Vida" });
								break;
						}
					}
					else {
						dispatch({
							"type": "MODAL_ALERT_MESSAGES_SHOW",
							"titulo": "Error",
							"mensaje": "Hubo un error al validar el OTP. Favor de intentar más tarde."
						});
					}
				}
			}

			//}
		}).catch(error => {
			dispatch({
				"type": "MI_PERFIL_SET_LOAD_LOCAL",
				"load": false
			});
			$(modalCodPol).modal("toggle");
			if (error.message.mensaje !== "") {
				dispatch({
					"type": "MODAL_ALERT_MESSAGES_SHOW",
					"titulo": "Error",
					"mensaje": "Hubo un error al validar el OTP. Favor de intentar más tarde."
				});
			}
		});
	};
};

function download(base64Data, sArchivo, bZip) {
	var arrBuffer = base64ToArrayBuffer(base64Data);

	// It is necessary to create a new blob object with mime-type explicitly set
	// otherwise only Chrome works like it should
	var newBlob;
	if (bZip) {
		newBlob = new Blob([arrBuffer], { type: "application/zip" });
	} else {
		newBlob = new Blob([arrBuffer], { type: "application/pdf" });
	}
	console.log(newBlob);

	// IE doesn't allow using a blob object directly as link href
	// instead it is necessary to use msSaveOrOpenBlob
	if (window.navigator && window.navigator.msSaveOrOpenBlob) {
		window.navigator.msSaveOrOpenBlob(newBlob);
		return;
	}
	saveAs(newBlob, sArchivo);
	// For other browsers:
	// Create a link pointing to the ObjectURL containing the blob.
	// var data = window.URL.createObjectURL(newBlob);
	// console.log(data);
	// var link = document.createElement('a');
	// document.body.appendChild(link); //required in FF, optional for Chrome
	// link.href = data;
	// link.download = "file.pdf";
	// link.target = "_blank";
	// link.click();
	// window.URL.revokeObjectURL(data);
	// link.remove();
}

function base64ToArrayBuffer(data) {
	var binaryString = window.atob(data);
	var binaryLen = binaryString.length;
	var bytes = new Uint8Array(binaryLen);
	for (var i = 0; i < binaryLen; i++) {
		var ascii = binaryString.charCodeAt(i);
		bytes[i] = ascii;
	}
	return bytes;
}



// WEBPACK FOOTER //
// ./src/home/polizas.act.js